import { faChevronDown, faChevronUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { Plugin } from "prosemirror-state";

import { adjustSelectionToIncludeDescendants, getMoveSelection } from "~/lib/prose/commands";

import { Extension } from "../extension";

export class MoveSelection extends Extension {
	get name() {
		return "moveSelection";
	}

	get plugins() {
		let includedDescendants = false;

		return [
			new Plugin({
				props: {
					handleKeyDown: (view, event) => {
						if (event.metaKey || event.ctrlKey) {
							if (includedDescendants && (event.code === "ArrowUp" || event.code === "ArrowDown")) {
								adjustSelectionToIncludeDescendants(view.state, view.dispatch);
								includedDescendants = false;
							}

							if (event.code === "ArrowUp") {
								getMoveSelection("up")(view.state, view.dispatch, view);
								event.preventDefault();
								return true;
							} else if (event.code === "ArrowDown") {
								getMoveSelection("down")(view.state, view.dispatch, view);
								event.preventDefault();
								return true;
							} else {
								// reset the flag so that the next time we press up/down it'll include descendants
								includedDescendants = true;
							}
						}
						return false;
					},
				},
			}),
		];
	}

	menuEntry() {
		return [
			{
				icon: faChevronUp,
				title: "Move Up",
				mobileOnly: true,
				greyIfDryRunFalse: true,
				run: () => {
					return getMoveSelection("up");
				},
				group: "indent",
			},
			{
				icon: faChevronDown,
				title: "Move Down",
				mobileOnly: true,
				greyIfDryRunFalse: true,
				run: () => {
					return getMoveSelection("down");
				},
				group: "indent",
			},
		];
	}
}

export default MoveSelection;
